import { render, staticRenderFns } from "./AddArtVideo.vue?vue&type=template&id=4e0e1016&"
import script from "./AddArtVideo.vue?vue&type=script&lang=js&"
export * from "./AddArtVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports